export * from "./MessageComponent";

import { MessageComponent } from "./MessageComponent";
export default MessageComponent;
